import axios from 'axios'
axios.defaults.baseURL = `${process.env.REACT_APP_API_URL}/api`

const NonConformity = 'NonConformityIncidences'

export const getNonConformities = (filters) => {
  return axios.post(`/${NonConformity}/PaginatedAndFiltered`, filters)
}

export const getNonConformity = (id) => {
  return axios.get(`/${NonConformity}/${id}`)
}

export const acceptNonConformity = (data) => {
  return axios.put(`/${NonConformity}`, data)
}
